/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Bracket structure type - how teams progress through the competition.
 * @export
 */
export const BracketType = {
    SINGLE_ELIMINATION: 'SINGLE_ELIMINATION',
    DOUBLE_ELIMINATION: 'DOUBLE_ELIMINATION',
    ROUND_ROBIN: 'ROUND_ROBIN',
    SWISS: 'SWISS',
    GROUPS_KNOCKOUT: 'GROUPS_KNOCKOUT'
} as const;
export type BracketType = typeof BracketType[keyof typeof BracketType];


export function instanceOfBracketType(value: any): boolean {
    for (const key in BracketType) {
        if (Object.prototype.hasOwnProperty.call(BracketType, key)) {
            if (BracketType[key as keyof typeof BracketType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function BracketTypeFromJSON(json: any): BracketType {
    return BracketTypeFromJSONTyped(json, false);
}

export function BracketTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): BracketType {
    return json as BracketType;
}

export function BracketTypeToJSON(value?: BracketType | null): any {
    return value as any;
}

export function BracketTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): BracketType {
    return value as BracketType;
}

